import { Alert } from "@chakra-ui/react";
import { t } from "i18next";

export const NoCommentsAlert: React.FC = () => {
  return (
    <Alert.Root status="info">
      <Alert.Indicator />
      <Alert.Description fontSize="sm">
        {t("map:comments.noComments")}
      </Alert.Description>
    </Alert.Root>
  );
};
